import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseCardsInFabricationProps<T> = {
  filters?: {
    type?: string;
    search?: string;
    company_id?: string;
    status?: string;
    page?: number;
  };
  mapper?: (data: any) => T,
};

export const useCardsInFabrication = <T,>({
  filters: { type, search, company_id, status, page } = {},
  mapper = Mapper.default<T>(),
}: UseCardsInFabricationProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['clientCardsInFabrication', type, search, company_id, status, page],
    queryFn: () => {
      return privateAxios.get(`/client/cards/in_fabrication`, {
        params: {
          'q[type_eq]': type,
          search,
          'q[company_id_eq]': company_id,
          'q[status_eq]': status,
          page,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
